import { FormattedMessage, useIntl } from 'react-intl'
import { Link } from '@tanstack/react-router'

import { ArrowLeftEndOnRectangleIcon } from '@gto/icons-react/solid/arrow-left-end-on-rectangle'
import { IconGtoWizardLogo } from '@gto/ui/assets'
import { Tooltip } from '@gto/ui/tooltip'

import { useAuth } from '@/hooks/use-auth'

import { ICON_SIZE, NavList } from './nav-list'

export { ADMIN_NAV_ITEMS, PARTNER_NAV_ITEMS } from './nav-list'

export const Sidebar = () => {
  const { onLogout } = useAuth()
  const { formatMessage } = useIntl()

  return (
    // requires no overflow on any ancestor — document is the scroll container
    <nav className="sticky top-2 z-drawer m-2 flex h-[calc(100dvh-16px)] w-20 shrink-0 flex-col items-center self-start overflow-y-auto overflow-x-hidden rounded-md bg-gradient-paper1 px-1 py-3 md:hidden">
      <div className="mb-4">
        <Link
          style={{ textDecoration: 'none' }}
          to="/login"
        >
          <IconGtoWizardLogo
            style={{ height: 24, width: 'auto', color: 'var(--clr-primary, #AAFBB2)' }}
          />
        </Link>
      </div>

      <NavList />

      <div className="grow" />

      <Tooltip
        content={<FormattedMessage id="nav.logout" />}
        placement="right"
      >
        <button
          aria-label={formatMessage({ id: 'nav.logout' })}
          className="flex size-10 cursor-pointer items-center justify-center border-0 bg-transparent p-0 text-text-secondary transition-colors duration-150 hover:text-error-main"
          type="button"
          onClick={() => onLogout()}
        >
          <ArrowLeftEndOnRectangleIcon
            height={ICON_SIZE}
            width={ICON_SIZE}
          />
        </button>
      </Tooltip>
    </nav>
  )
}
